export default __webpack_public_path__ + "beta-maps-guides-migrate-custom-render-960-70ddc0d8fff522ec01b43ef50831c4d7.webp";